export default function ExecutionStatusField({ executionStatus }) {
  return (
    <p
      className="w-full rounded p-2 default_operational_status"
      style={{
        textAlign: 'center',
        background: executionStatus?.BackgroundColor,
        color: executionStatus?.ForegroundColor,
        borderRadius: '40px',
      }}
    >
      {executionStatus?.Name}
    </p>
  );
}
